module.exports = __webpack_public_path__ + "static/media/vic_flex_logo_l.140e167f.png";